import { createContext, useContext, useEffect, useState } from "react";

const STORAGE_KEY = "tarqia-language";
const LANGUAGES = ["en", "ar"];

const LanguageContext = createContext({ lang: "en", isRtl: false, setLang: () => { } });

const readStoredLanguage = () => {
    try {
        const stored = window.localStorage.getItem(STORAGE_KEY);
        return LANGUAGES.includes(stored) ? stored : "en";
    } catch (e) {
        return "en";
    }
};

export const LanguageProvider = ({ children }) => {
    const [lang, setLang] = useState(readStoredLanguage);
    const isRtl = lang === "ar";

    useEffect(() => {
        document.documentElement.lang = lang;
        document.documentElement.dir = isRtl ? "rtl" : "ltr";
        try {
            window.localStorage.setItem(STORAGE_KEY, lang);
        } catch (e) {
            // Storage can be unavailable (private mode); the choice then lasts for this visit only.
        }
    }, [lang, isRtl]);

    return (
        <LanguageContext.Provider value={{ lang, isRtl, setLang }}>
            {children}
        </LanguageContext.Provider>
    );
};

export const useLanguage = () => useContext(LanguageContext);
